/** Query param for focused thread (expanded view). camelCase matches TS / GraphQL conventions. */
export const FOCUS_MESSAGE_QUERY_KEY = 'focusMessageId';
